import React from 'react';
import { useSelector } from 'react-redux'
import * as actions from '../../store/actions/index';
import Projectunit from './Projectunit';


const Projectunits = (props) => {

  const unitsInSearch = (unit) => (unit.title && unit.title.toLowerCase().includes(props.filter.toLowerCase()) ||
                                  unit.description && unit.description.toLowerCase().includes(props.filter.toLowerCase()));


  const thisProjectunits = useSelector(state => {
    return (project) => actions.getInventoryObjects(state, 'projectunits', project.projectunits)
  });

  return (
    <div className="projectunits-container">
      { thisProjectunits(props.project).filter((x) => unitsInSearch(x))
                                       .sort((a, b) => a.position < b.position ? 1 : -1)
                                       .map(x => (
        <div key={x.id} className="projectunit-wrapper">
          <Projectunit
            unit={x}
            open={true}
            project={props.project}
          />
        </div>
      )) }
    </div>
  )
}

export default Projectunits;



// WEBPACK FOOTER //
// ./src/components/Project/Projectunits.js